import { gql } from '@apollo/client'

// ─── Session ──────────────────────────────────────────────────────────────────

export const OPEN_EOD_SESSION = gql`
  mutation OpenEodSession($date: String!) {
    openEodSession(date: $date) {
      id
      date
      status
      general_notes
      notes_for_tomorrow
      incidents {
        id
        eod_session_id
        description
        severity
        created_by
        created_at
      }
      created_by
      submitted_by
      submitted_at
      last_modified_by
      created_at
      updated_at
    }
  }
`

export const UPDATE_EOD_SESSION = gql`
  mutation UpdateEodSession($id: Int!, $data: UpdateEodSessionInput!) {
    updateEodSession(id: $id, data: $data) {
      id
      general_notes
      notes_for_tomorrow
      updated_at
    }
  }
`

export const SUBMIT_EOD_SESSION = gql`
  mutation SubmitEodSession($id: Int!) {
    submitEodSession(id: $id) {
      id
      status
      submitted_by
      submitted_at
      updated_at
    }
  }
`

export const REOPEN_EOD_SESSION = gql`
  mutation ReopenEodSession($id: Int!) {
    reopenEodSession(id: $id) {
      id
      status
      updated_at
    }
  }
`

// ─── Incidents ────────────────────────────────────────────────────────────────

export const ADD_EOD_INCIDENT = gql`
  mutation AddEodIncident($session_id: Int!, $description: String!, $severity: EodIncidentSeverity) {
    addEodIncident(session_id: $session_id, description: $description, severity: $severity) {
      id
      eod_session_id
      description
      severity
      created_by
      created_at
    }
  }
`

export const DELETE_EOD_INCIDENT = gql`
  mutation DeleteEodIncident($id: Int!) {
    deleteEodIncident(id: $id)
  }
`

// ─── Inventory logging ────────────────────────────────────────────────────────

export const LOG_PRODUCTION_BATCH = gql`
  mutation LogProductionBatch($data: LogProductionBatchInput!) {
    logProductionBatch(data: $data) {
      id
      quantity
      ledger_date
    }
  }
`

export const LOG_TRANSACTION = gql`
  mutation LogTransaction($data: LogTransactionInput!) {
    logTransaction(data: $data) {
      id
      transaction_type
      quantity_delta
      ledger_date
    }
  }
`

export const SET_DAILY_TRANSACTION_TOTAL = gql`
  mutation SetDailyTransactionTotal($data: SetDailyTransactionTotalInput!) {
    setDailyTransactionTotal(data: $data)
  }
`

// ⚠️ Blocked — requires variantsWithTrackedIngredients backend query
export const LOG_OUTSIDE_SALE_BY_PORTIONS = gql`
  mutation LogOutsideSaleByPortions($data: LogOutsideSaleByPortionsInput!) {
    logOutsideSaleByPortions(data: $data) {
      id
      raw_material_id
      transaction_type
      quantity_delta
      ledger_date
    }
  }
`
